import { dayjs } from '@/utils/date/dayjs';

import { type TimeSlot } from './types';

export const formatDateTimestamp = (
  timestamp: number,
  patientLocalTimezone: string,
  monthFormat = 'MMM',
): string => {
  const zonedStart = dayjs(timestamp).tz(patientLocalTimezone);
  const today = dayjs().tz(patientLocalTimezone);
  const tomorrow = today.add(1, 'day');
  const monthDayLabel = zonedStart.format(`${monthFormat} D`);

  if (zonedStart.isSame(today, 'day')) {
    return `Today, ${monthDayLabel}`;
  }

  if (zonedStart.isSame(tomorrow, 'day')) {
    return `Tomorrow, ${monthDayLabel}`;
  }

  const weekdayLabel = zonedStart.format('dddd');

  return `${weekdayLabel}, ${monthDayLabel}`;
};

export const formatScheduledTimeRange = (
  timestamp: number,
  patientLocalTimezone: string,
): string => {
  const start = dayjs(timestamp).tz(patientLocalTimezone);
  const end = start.add(15, 'minute');

  return `Between ${start.format('h:mm A')} - ${end.format('h:mm A z')}`;
};

export type OptionsType = Array<{
  value: number;
  label: string;
}>;

export const generateDateOptions = (
  availableDateTimestamps: number[],
  patientLocalTimezone: string,
): OptionsType =>
  availableDateTimestamps.map((timestamp) => ({
    value: timestamp,
    label: formatDateTimestamp(timestamp, patientLocalTimezone),
  }));

export const generateTimeOptions = (
  availableTimeSlotsForDate: TimeSlot[],
  patientLocalTimezone: string,
): OptionsType =>
  availableTimeSlotsForDate.map((timeSlot) => ({
    value: timeSlot.id,
    label: dayjs(timeSlot.timestamp)
      .tz(patientLocalTimezone)
      .format('h:mm A z'),
  }));
